import React, {useCallback, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {CONFIRM_PROPOSAL_PROMPT} from '../../utils/agentProposalHold';
import {getProposalConfirmLabel} from '../../utils/proposalConfirmLabel';
import type {AiAgentPendingProposal} from '../../../../redux/aiAgent/aiAgent.type';
import type {SubmitPromptOptions} from '../../../aiMessageGenerator/utils/types';
import * as css from './AiAgentProposalConfirm.css';

interface AiAgentProposalConfirmProps {
    proposal: AiAgentPendingProposal;
    disabled?: boolean;
    onSubmitPrompt: (options?: SubmitPromptOptions) => void;
}

/** The details are in the message this sits in — pressing it answers that message, and only it creates. */
function AiAgentProposalConfirm({proposal, disabled = false, onSubmitPrompt}: AiAgentProposalConfirmProps) {
    const {t} = useTranslation('aiAgent');
    const label = useMemo(() => getProposalConfirmLabel(proposal, t), [proposal, t]);

    const handleConfirm = useCallback(() => {
        if(disabled) {
            return;
        }
        onSubmitPrompt({text: CONFIRM_PROPOSAL_PROMPT, displayText: label});
    }, [disabled, onSubmitPrompt, label]);

    return (
        <css.confirmButton
            type="button"
            disabled={disabled}
            onClick={handleConfirm}
            data-cy="ai-agent-proposal-confirm"
        >
            {label}
        </css.confirmButton>
    );
}

export default AiAgentProposalConfirm;
